import React from 'react';
import { Button } from './ui/Button';
export function UsedSalesSection() {
  return <section className="py-16 md:py-24 bg-gradient-to-br from-orange to-orange/90 text-white" data-id="element-364">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-365">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-366">
          USED MACHINE SALES
        </h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-367">
          {/* Looking to Buy */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8" data-id="element-368">
            <h3 className="text-2xl font-bold mb-4" data-id="element-369">
              Looking for USED Wire or Sinker EDM?
            </h3>
            <p className="text-lg mb-6 leading-relaxed" data-id="element-370">
              Peak Machine Sales is the #1 resource for USED Wire & Sinker EDM
              machines and equipment of all makes and models throughout North
              America (and beyond!!)
            </p>
            <Button variant="secondary" href="59m7/used-machines.html" className="bg-white text-orange hover:bg-gray-100 border-0" data-id="element-371">
              USED MACHINE INVENTORY
            </Button>
          </div>

          {/* Looking to Sell */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8" data-id="element-372">
            <h3 className="text-2xl font-bold mb-4" data-id="element-373">
              Looking to sell your well maintained Wire or Sinker EDM?
            </h3>
            <p className="text-lg mb-6 leading-relaxed" data-id="element-374">We're interested!</p>
            <Button variant="secondary" href="https://www.peakedm.com/SellingUsedEDM?" external className="bg-white text-orange hover:bg-gray-100 border-0" data-id="element-375">
              SELL YOUR USED EDM MACHINE TODAY
            </Button>
          </div>
        </div>
      </div>
    </section>;
}